import { Photos } from 'ha/services/apiV2/types/Photos';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface PhotoParams {
  format?: string;
  crop?: boolean;
}

export default (makeCall: MakeCall) => (
  listingId: string | number,
  { format, crop }: PhotoParams,
) =>
  makeCall<Photos>('GET', `${APIV2_URL}/listing/${listingId}/photos`, {
    query: { format, crop },
  });
